<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>报表管理</el-breadcrumb-item>
      <el-breadcrumb-item>工资汇总报表</el-breadcrumb-item>
    </el-breadcrumb>
    <div style="display: flex;justify-items: center">
      <el-date-picker
        v-model="reportRequestBody.selectMonth"
        size="mini"
        type="monthrange"
        range-separator="至"
        start-placeholder="开始月份"
        end-placeholder="结束月份"
        @change="selectReportDataMonth"
        value-format="yyyy-MM"
      >
      </el-date-picker>
      <el-select value filterable v-model="selectAreaId"
                 v-if="orgLevel == 1"
                 placeholder="请选择区域" clearable style="width: 200px;margin-left: 5px"
                 size="mini" @change="getArea">
        <el-option
          v-for="item in area"
          :key="item.id"
          :label="item.orgName"
          :value="item.id">
        </el-option>
      </el-select>
      <el-select v-model="selectOrgId" clearable value
                 v-if="orgLevel < 3"
                 filterable placeholder="请选择门店"
                 style="margin-left: 5px;width: 200px" size="mini" @change="getShop">
        <el-option
          v-for="org in shop"
          :key="org.id"
          :label="org.orgName"
          :value="org.id">
        </el-option>
      </el-select>
      <el-select v-model="reportRequestBody.userId" clearable value filterable placeholder="请选择员工"
                 style="width: 200px" size="mini" @change="getUser">
        <el-option
          v-for="user in users"
          :key="user.id"
          :label="user.userName"
          :value="user.id">
        </el-option>
      </el-select>
      <el-button size="mini" style="margin-left: 5px" @click="loadSalaryData">查询</el-button>
    </div>
    <el-table height="650px" :data="salaryList" fit border stripe="stripe"
              :header-cell-style="{background:'#eff3f8', color:'#333'}"
              show-summary >
      <el-table-column
        align="center"
        prop="reportYearMonth"
        label="日期"
        width="150"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="areaName"
        label="区域"
        width="150"
        v-if="orgLevel == 1"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="shopName"
        label="门店"
        width="150"
        v-if="orgLevel <= 2"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="serverName"
        label="姓名"
        width="150"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="jixiaogongzi"
        label="绩效工资"
        width="150"
      >
      </el-table-column>
      <el-table-column
        v-for="(item, index) in tableTitle"
        align="center"
        :key="item.costId"
        :prop="item.costEnName"
        width="150"
        :render-header="(h, obj) => renderHeader(h, obj, item.costCnName)"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="heji"
        label="合计"
        width="150"
      >
      </el-table-column>
    </el-table>
    <span class="showFont">
      合计 = 餐补 + 车补 + 收银补助 + 房补 + 其他补助 + 绩效工资 + 员工奖金 + 员工其他收入 - 员工社保 - 员工工会费 - 员工公积金 - 员工乐捐
      - 员工其他支出 - 员工个税
    </span>
    <br>
    <span class="showFont">
      绩效工资 = 足科提成 + 团购提成 + 按摩提成 + 修复及矫正提成 + 华连生产品提成 + 洁沃产品提成 + 贝尔产品提成 + 会员卡充值提成 - 会员卡退费提成
      - 消费单退费会员提成 - 消费单退费现金提成
    </span>
  </div>
</template>

<script>
export default {
  data(){
    return{
      orgId:'',
      userId:'',
      orgLevel:'',
      tableTitle:[],
      salaryList:[],
      area:[],
      shop:[],
      users:[],
      reportRequestBody:{
        startDate:'',
        endDate:'',
        shopId:'',
        areaId:'',
        orgId:'',
        selectMonth:'',
        userId:'',
        orgLevel:'',
        startMonth:'',
        endMonth:'',
        authName:'',
        groupValue:'',
      },
      selectAreaId:'',
      selectOrgId:'',
      selectUserId:'',
      authName:'',
      groupValue:'',
    }
  },
  methods:{
    async loadSalaryData(){
      this.reportRequestBody.startMonth = this.getCurrentMonth();
      this.reportRequestBody.endMonth = this.getCurrentMonth();
      if (this.reportRequestBody.selectMonth !== '' && this.reportRequestBody.selectMonth != null){
        this.reportRequestBody.startMonth = this.reportRequestBody.selectMonth[0];
        this.reportRequestBody.endMonth = this.reportRequestBody.selectMonth[1];
      }
      if (this.orgLevel == 2){
        this.reportRequestBody.orgLevel = this.orgLevel;
        this.reportRequestBody.areaId = this.orgId;
      }
      if (this.orgLevel == 3){
        this.reportRequestBody.orgLevel = this.orgLevel;
        this.reportRequestBody.shopId = this.orgId;
      }
      this.reportRequestBody.dataAuth = this.authName;
      this.reportRequestBody.authValue = this.groupValue;
      this.reportRequestBody.loginId = this.userId;
      await this.loadTableTitle();
      const {data:res} = await this.$http.post(`/salary/collect/data`, this.reportRequestBody)
      this.salaryList = res.data;
    },
    async loadAreaOrgs(){
      const {data:res} = await this.$http.get(`/orgs/area/orgId/${this.orgId}`);
      if (res.code === 200){
        this.area = res.data;
      }
    },
    async loadTableTitle(){
      const {data:res} = await this.$http.get(`/salary/collect/header/orgId/${this.orgId}`)
      this.tableTitle = res.data;
    },
    // 自定义表头
    renderHeader(h, { column, $index }, type) {
      let that = this;
      return h(
        'div', [
          // 列名称
          h('span', column.label),
          // 按钮
          h('span', {
            props: {
              type: 'text',
              size: 'small',
            },
            style: 'margin-left: 5px;height:20px;padding-top: 2px;color:#333',
          }, type)
        ],
      )
    },
    async getArea(data){
      this.reportRequestBody.areaId = data;
      if (data === ''){
        this.reportRequestBody.areaId = 0;
      }
      const {data:res} = await this.$http.get(`/orgs/area/orgId/${data}`);
      this.shop = res.data;
    },
    async getShop(data){
      this.reportRequestBody.shopId = data;
      this.reportRequestBody.orgId = data;
      if (data === ''){
        this.reportRequestBody.orgId = 0;
        this.reportRequestBody.shopId = 0;
      }

      const {data:res} = await this.$http.get(`/org/users/${data}`);
      this.users = res.data;
    },
    async loadShop(){
      const {data:res} = await this.$http.get(`/orgs/area/orgId/${this.orgId}`);
      this.shop = res.data;
    },
    getCurrentMonth () {
      let date = new Date()
      date.setDate(1)
      let month = parseInt(date.getMonth() + 1)
      if (month < 10) month = '0' + month
      return date.getFullYear() + '-' + month;
    },
    selectReportDataMonth(data){
      if (data == null){
        this.reportRequestBody.selectMonth = '';
      } else {
        this.reportRequestBody.selectMonth = data;
      }
    },
    getUser(data){
      if (data !== ''){
        this.reportRequestBody.userId = data;
      } else {
        this.reportRequestBody.userId = '';
      }
    },
    async loadUser(){
      const {data:res} = await this.$http.get(`/org/users/${this.orgId}`);
      this.users = res.data;
    },
    async loadAllUser(){
      const {data:res} = await this.$http.get(`/report/users`);
      this.users = res.data;
    },
    async loadGroupShop(){
      const {data:res} = await this.$http.get(`/group-org`,
        { params:{userId: this.userId, groupValue: this.groupValue}});
      this.shop = res.data;
    },
  },
  created() {
    this.orgId = window.sessionStorage.getItem('currentOrgId');
    this.userId = window.sessionStorage.getItem("userId");
    this.orgLevel = window.sessionStorage.getItem("orgLevel");
    this.authName = window.sessionStorage.getItem('authName');
    this.groupValue = window.sessionStorage.getItem('groupValue');
    if (this.orgLevel == 1){
      this.loadAreaOrgs();
    }
    if (this.orgLevel == 2){
      this.reportRequestBody.orgLevel = this.orgLevel;
      this.reportRequestBody.areaId = this.orgId;
      if(this.authName === 'group'){
        this.loadGroupShop();
      } else {
        this.loadShop();
      }
      this.loadAllUser();
    }
    if (this.orgLevel == 3){
      this.reportRequestBody.orgLevel = this.orgLevel;
      this.reportRequestBody.shopId = this.orgId;
      this.loadUser();
    }
    this.loadTableTitle();
    this.loadSalaryData();
  }
}
</script>

<style lang="less" scoped>
.el-table, .el-table__cell {
  /deep/ th {
    padding: 2px ;
    text-align: center !important;
  }
  /deep/ td {
    padding: 2px ;
  }
}
/deep/.el-input__inner{
  height: 30px;
  line-height: 30px;
}
/deep/.el-input__icon,.el-icon-date{
  line-height: 35px;
}
/deep/.el-input__icon, .el-range__icon, .el-icon-date{
  line-height: 25px;
}
/deep/.el-range-separator{
  line-height: 23px;
}
.dialog-footer{
  display: flex;
  margin: 30px 20px 20px 0;
  justify-content: center;
  width: 100%;
}
/deep/.el-button--text{
  color: #ecf5ff;
}
.el-table {
  overflow: visible !important;
}

/deep/.el-tabs--card>.el-tabs__header {
  border-bottom: 1px solid #E4E7ED;
}
/deep/.el-tabs__header {
  padding: 0;
  position: relative;
  margin: 0 0 10px;
}
/deep/.el-tabs__content {
  overflow: hidden;
  position: relative;
  height: 600px;
}
.showFont{
  font-size: 14px;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/SalaryCollect.vue